"use client";

/**
 * Skip-to-content link visible sólo al focus con teclado.
 * Permite a usuarios de screen reader / teclado saltar el ribbon y sidebar.
 */
export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="
        absolute top-2 left-2 z-[600] px-3 py-2
        rounded-md bg-primary text-primary-foreground text-xs font-semibold
        shadow-lg shadow-primary/30
        opacity-0 -translate-y-2 pointer-events-none
        focus:opacity-100 focus:translate-y-0 focus:pointer-events-auto
        transition-all
      "
    >
      Saltar al contenido principal
    </a>
  );
}
